import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { ASSETS } from "@/lib/content";

export const VideoModal = ({ open, onClose }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        data-testid="video-modal"
        className="fixed inset-0 z-[100] grid place-items-center p-4 sm:p-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div
          className="absolute inset-0 bg-navy-950/85 backdrop-blur-md"
          onClick={onClose}
          data-testid="video-modal-overlay"
        />
        <motion.div
          className="relative w-full max-w-4xl"
          initial={{ scale: 0.92, y: 24, opacity: 0 }}
          animate={{ scale: 1, y: 0, opacity: 1 }}
          exit={{ scale: 0.95, y: 12, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        >
          <button
            data-testid="video-modal-close"
            onClick={onClose}
            className="absolute -top-12 right-0 flex items-center gap-2 text-white/80 hover:text-white transition-colors"
          >
            <span className="text-sm">Kapat</span>
            <X className="h-6 w-6" />
          </button>
          <div className="overflow-hidden rounded-2xl border border-white/10 shadow-2xl shadow-black/60 bg-black">
            <video
              data-testid="promo-video"
              controls
              autoPlay
              playsInline
              className="w-full aspect-video"
            >
              <source src={ASSETS.video} type="video/mp4" />
              Tarayıcınız bu videoyu oynatamıyor.
            </video>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
